module.exports = __webpack_public_path__ + "static/media/checkout-new-mobile.317d572c.png";